(function() {
    'use strict';

    angular
        .module('app')
        .directive('modifycolumns', modifycolumns);

    modifycolumns.$inject = ['$timeout', 'columnSetService', '$localStorage', '$filter', 'loginService'];
    
    function modifycolumns($timeout, columnSetService, $localStorage, $filter, loginService) {
        // Usage:
        //     <modifycolumns></modifycolumns>
        // Creates:
        // 
        var directive = {
            link: link,
            scope: {
                current: '=',
                all: '=',
                shown: '=',
                csid: '=',
                onApply: '&',
                startDrag: '=',
                endDrag: '='
            },
            restrict: 'EA',
            templateUrl: "app/gridsettings/templates/modifycolumns.html"
        };
        return directive;

        function link(scope, element, attrs) {
            //draggable options
            scope.processing = false;
            var allCopy = [];
            var currentCopy = [];
            var applied = false;
            var changed = false;
            scope.limiter = 13;

            scope.allColumnsLabel = loginService.resourceStrings["ALL_COLUMNS"]; // "All Columns"
            scope.currentColumnsLabel = loginService.resourceStrings["CURRENT_COLUMNS"]; // "Current Columns"

            $timeout(function () {
                scope.limiter = 1000;
            }, 2000);

            $(element).find(".add-column-list").each(function (key, value) {
                $(value).scroll(function () {
                    scope.limiter = scope.limiter + 30;
                    scope.$apply();
                })
            })

            scope.draggableOptions = {
                container: "column",
                connectWith: ".grid-columns",
                start: startDrag,
                stop: endDrag
            };

            function startDrag() {
                console.log("Modify Columns Current");
                console.log(scope.current);
                scope.startDrag();
            }

            function endDrag() {
                scope.endDrag();
            }
        }
    }

})();